import './modal_link_creator.less';

import React from 'react';

import LinkCreatorWithDefaults from 'zoomforth_shared_management/components/link_creator_with_defaults.jsx';
import SimpleModalWithHeader from 'zoomforth_component_lib/simple_modal_with_header.jsx';
import TruncatedText from 'zoomforth_component_lib/truncated_text.jsx';
import { PageIcon } from 'zoomforth_component_lib/app_modern_icons.jsx';


const CreateLinkModal = ({ closeOnOuterClick, ...props })=>
  <SimpleModalWithHeader
    show={true}
    className="create-link-modal"
    closeOnOuterClick={closeOnOuterClick}
    onRequestClose={props.onRequestClose}
    title={
      <TruncatedText>
        Create Link <span className="title-extra"><PageIcon /> {props.page.get('name')}</span>
      </TruncatedText>
    }
  >
    <LinkCreatorWithDefaults {...props}/>
  </SimpleModalWithHeader>;

CreateLinkModal.defaultProps = {
  closeOnOuterClick: true
};

export default CreateLinkModal;
